module.exports = __webpack_public_path__ + "img/20201209_135428.89d9c454.jpg";